/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';

import { MotionLazy } from 'src/components/animate/motion-lazy';
import ProgressBar from 'src/components/progress-bar';
import { SettingsProvider } from 'src/components/settings';
import 'src/global.css';
import { useScrollToTop } from 'src/hooks/use-scroll-to-top';
import 'src/locales/i18n';
import Router from 'src/routes/sections';
import ThemeProvider from 'src/theme';

import { useAuth } from './auth/auth.hook';
import { SnackbarProvider } from './components/snackbar';
import { LocalizationProvider } from './locales';

export default function App() {
  useScrollToTop();
  const { initializeAuth } = useAuth();

  useEffect(() => {
    initializeAuth();
  }, []);

  return (
    <LocalizationProvider>
      <SettingsProvider
        defaultSettings={{
          themeMode: 'light', // 'light' | 'dark'
          themeDirection: 'ltr', //  'rtl' | 'ltr'
          themeContrast: 'default', // 'default' | 'bold'
          themeLayout: 'horizontal', // 'vertical' | 'horizontal' | 'mini'
          themeColorPresets: 'default', // 'default' | 'cyan' | 'purple' | 'blue' | 'orange' | 'red'
          themeStretch: false,
        }}
      >
        <ThemeProvider>
          <MotionLazy>
            <SnackbarProvider>
              <ProgressBar />
              <Router />
            </SnackbarProvider>
          </MotionLazy>
        </ThemeProvider>
      </SettingsProvider>
    </LocalizationProvider>
  );
}
